import administrator from "./administrator";
import choice from "./choice";
import enrollment from "./enrollment";
import requestor from "./requestor";
import signatory from "./signatory";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  //items: [home, administrator, requestor, signatory]
  items: [administrator, enrollment, choice, requestor, signatory],
};

export default menuItems;
